import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { LangService } from 'src/app/services/lang.service';
import { Lang } from 'src/app/models/lang';
import { Strings } from '../../const/strings';
import { MenuDialogComponent } from '../menu-dialog/menu-dialog.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit {

  @Input() headerNavVisible = true;

  appUrl: string;
  lang: Lang;
  strings = Strings;

  constructor(
    public dialog: MatDialog,
    private langService: LangService,
  ) { }

  ngOnInit() {
    this.appUrl = this.langService.getAppUrl();
    this.lang = this.langService.getCurrentLang();
  }

  openMenu() {
    this.dialog.open(MenuDialogComponent, {
      id: 'mobile-menu-dialog',
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      data: { }
    });
  }

}
